import { IPublicRequestMetersData } from 'app/pages/request-single-page/request-single-page-slice';
import { IconWrapper, Wrapper } from './meter-card.styled';
import {
  HStack,
  SVG,
  Text,
  VStack,
  Divider,
  Hint,
} from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { MetersVariants } from '../../../meters/constants';
import { MeterReadingRow } from './ui/meter-reading-row';
import { useResponsive } from 'app/hooks';
import { AutomaticIcon } from '../../../meters/meter/ui/automatic-icon';

export const MeterCard = ({
  id,
  type,
  serial_number,
  is_automatic,
  unit,
  last_readings,
}: IPublicRequestMetersData) => {
  const theme = useV4Theme();
  const { viewport } = useResponsive();

  const {
    color: meterColor,
    icon: meterIcon,
    readings: meterReadings,
    digitCapacity,
  } = MetersVariants[type.type];

  return (
    <Wrapper>
      <HStack
        padding={`${theme.spacings.xs} ${theme.spacings.s}`}
        spacing="xs"
        style={{
          backgroundColor: theme.colors.gray[50],
          borderRadius: theme.radiuses.xs,
        }}
      >
        <IconWrapper $color={meterColor}>
          <SVG src={meterIcon} />
        </IconWrapper>

        <VStack spacing="none">
          <HStack align="center" spacing="xxs">
            <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
              {type.type_ru}
            </Text>

            {is_automatic && <AutomaticIcon />}
          </HStack>
          <Text
            variant={viewport.mobile ? 'body-14' : 'body-16'}
            color="gray.500"
          >
            {serial_number}
          </Text>
        </VStack>
      </HStack>

      <VStack spacing="s">
        {is_automatic
          ? meterReadings.map(({ label }, index) => (
              <VStack key={index} spacing="s">
                <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
                  {label && `${label}: `}
                  {parseFloat(last_readings[index]?.value ?? '0').toFixed(2)}
                  {` ${unit}`}
                </Text>
                {index < meterReadings.length - 1 && <Divider />}
              </VStack>
            ))
          : meterReadings.map(({ label }, index) => (
              <MeterReadingRow
                key={index}
                meterId={id}
                meterType={type.type}
                index={index}
                label={label}
                lastReading={last_readings[index]}
                unit={unit}
                digitCapacity={digitCapacity}
                showDivider={index < meterReadings.length - 1}
              />
            ))}
      </VStack>
    </Wrapper>
  );
};
